import type { Component } from 'vue'
import IconAetoskyGreen from '@/components/icons/IconAetoskyGreen.vue'
import IconExploration from '@/components/icons/IconExploration.vue'
import IconChangeDetection from '@/components/icons/IconChangeDetection.vue'
import IconTerrainAnalysisAndVisualization from '@/components/icons.new/sidebar/IconTerrainAnalysisAndVisualization.vue'
import Icon3DCity from '@/components/icons.new/sidebar/Icon3DCity.vue'
import IconDemGeneration from '@/components/icons.new/sidebar/IconDemGeneration.vue'
import IconDataManagement from '@/components/icons.new/sidebar/IconDataManagement.vue'
import IconTasksManagement from '@/components/icons.new/sidebar/IconTasksManagement.vue'
import type { MenuIconKey } from '@/constant/menu'

const MENU_ICON_COMPONENTS: Record<MenuIconKey, Component> = {
  'terrain-analysis': IconTerrainAnalysisAndVisualization,
  city: Icon3DCity,
  dem: IconDemGeneration,
  data: IconDataManagement,
  tasks: IconTasksManagement,
  exploration: IconExploration,
  'change-detection': IconChangeDetection,
}

export const resolveMenuIcon = (key?: MenuIconKey): Component =>
  (key && MENU_ICON_COMPONENTS[key]) || IconAetoskyGreen
